import { useState } from "react";
import { IonHeader, IonTitle, IonToolbar } from "@ionic/react";
import { Loader, Segment, Segments } from "components";
import { useFeatureFlags } from "swing-components";

import { FilterBar } from "~components/Organisms/IndexFilters";
import { initialLocalStorageFilterValues } from "~components/Organisms/IndexFilters/types";
import { translate, useLocalStorage } from "~utils";

import { SegmentName, SegmentNameUnion, useRequestIndexFilters, useRequests } from "./hooks";
import { RequestCount } from "./RequestCount";
import { RequestIndex } from "./RequestIndex";
import { getNoRequestsHeader } from "./utils";

const INITIAL_ACTIVE_TAB_VALUE = SegmentName.Unfilled;

export function ActiveRequestsPage() {
  const [activeTab, setActiveTab] = useState<SegmentNameUnion>(INITIAL_ACTIVE_TAB_VALUE);
  const { flags } = useFeatureFlags();
  const showFilters = Boolean(flags.adminFiltersFe ?? false);

  const { data, isError } = useRequests({
    showHistory: false,
    filterSegment: activeTab,
    getUnfilteredData: showFilters,
  });

  const [ls, setLs] = useLocalStorage(
    "swing-schools:filters:active",
    initialLocalStorageFilterValues,
  );

  const filteredRequests = useRequestIndexFilters(ls, data?.requests);

  if (!data) return <Loader />;

  const activeRequestsSegments: Segments = [
    {
      value: INITIAL_ACTIVE_TAB_VALUE,
      label: translate("LABEL_ACTIVE_UNFILLED_REQUEST_INDEX_TAB"),
      count: data.counts.active[SegmentName.Unfilled],
    },
    {
      value: SegmentName.Waitlist,
      label: translate("LABEL_ACTIVE_WAITLIST_REQUEST_INDEX_TAB"),
      count: data.counts.active[SegmentName.Waitlist],
    },
    {
      value: SegmentName.Filled,
      label: translate("LABEL_ACTIVE_FILLED_REQUEST_INDEX_TAB"),
      count: data.counts.active[SegmentName.Filled],
    },
  ];

  const noRequestHeaderString = getNoRequestsHeader(activeTab, "active-requests");

  return (
    <>
      <IonHeader collapse="condense">
        <IonToolbar>
          <IonTitle size="large">{translate("ROUTE_TABLE_ACTIVE_REQUESTS")}</IonTitle>
        </IonToolbar>
      </IonHeader>
      {showFilters ? (
        <>
          <FilterBar page="active" ls={ls} setLs={setLs}></FilterBar>
          <RequestCount page="active" count={filteredRequests.length} />
        </>
      ) : (
        <Segment
          segments={activeRequestsSegments}
          initialValue={activeTab}
          onSegmentChange={setActiveTab}
        />
      )}
      <RequestIndex
        requestType="active-requests"
        requests={showFilters ? filteredRequests : data?.requests}
        noRequestHeaderString={noRequestHeaderString}
        isError={isError}
      />
    </>
  );
}
